<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="betteruptimeTicketModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Create Ticket for {{ from === 'diskAlert' ? 'Disk Alert' : 'Outages' }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section>
                <div v-if="recentTickets.length>0" class="row">
                  <div  class="col-md-12">
                    <h6>Recently Created Tickets:</h6>
                    <div class="row mt-2" v-for="(row, index) in recentTickets" :key="index">
                      <!--                        {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}}-->
                      <div class="col-md-12">{{ formatDate(row.createdAt) }}  <b>- </b>  <a :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`" target="_blank">{{row.ticketId}}</a> <b v-if="row.subject"> -</b> {{row.subject || ''}}  <b> -</b>
                        <small><span class="fs-10 badge mr-2 ml-5" :class="{'badge-primary':(row.status === 'Open'),'badge-default':(row.status ===  'Closed'), 'badge-danger':(row.status ===  'Client-Reply'), 'badge-success': (row.status ===  'Answered'),'badge-info': (row.status ===  'In-Progress'), 'badge-warning': row.status === 'Requires Customer Update'}">{{ row.status }}</span></small>
                        <b> -</b>  by <b>{{ row.addedBy }}</b></div>
                    </div>
                    <hr>
<!--                    <span v-for="(row, index) in tickets" :key="index">-->
<!--                    {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}} <br>-->
<!--                  </span>-->
                  </div>
                  <br>
                </div>
              </section>
              <section>
                <div class="row">
                  <div class="col-md-12">
                    <div>
                      <label>Subject:</label>
                      <span v-if="from === 'diskAlert'">
                        <span v-if="!refreshDiskSpaceLoader">
                          <button v-if="!processingJobs.length" @click="refreshDisk" class="pull-right btn btn-sm btn-primary mt-0 mb-0">
                            Refresh Storage
                          </button>
                          <button data-toggle="tooltip" data-placement="top" title="Storage refresh is already in progress. Please wait before sending another request." v-else class="pull-right make-cursor-pointer btn btn-sm  mt-0 mb-0" style="background-color: grey">
                            Refresh Storage
                          </button>
                        </span>
                        <button v-else class="pull-right btn btn-sm btn-primary mt-0 mb-0">
                          <i class="fa fa-spin fa-spinner pull-right"></i>
                        </button>
                      </span>
                    </div>
                    <input type="text" v-model="subject" name="subject" class="form-control" />
                  </div>
                </div>
                <section>
                  <div class="row mt-3" >
                    <div :class="from === 'diskAlert' ? 'col-md-12' : 'col-md-6'">
                      <div>
                        <label>Message:</label>
                      </div>
                      <textarea class="form-control" rows="8" v-model="ticketMessage"></textarea>
                    </div>
                    <div v-if="from !== 'diskAlert'" class="col-md-6">
                      <label>Presets:</label>
                      <ul class="list-unstyled preset">
                        <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                          <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                          <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label>Select Status:</label>
                      <select class="form-control" v-model="ticketStatus">
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                        <option value="Client-Reply">Client-Reply</option>
                        <option value="In-Progress">In-Progress</option>
                        <option value="Answered">Answered</option>
                        <option value="Requires Customer Update">Requires Customer Update</option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label>Select Priority:</label>
                      <select class="form-control" v-model="ticketPriority">
                        <option value="High">High</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                      </select>
                    </div>
                  </div>
                  <!--                    <div class="row">-->
                  <!--                      <div class="col-md-12" v-if="action !== 'Leave in migration'">-->
                  <!--                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">-->
                  <!--                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />-->
                  <!--                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                </section>
                <div class="row">
                  <div class="col-md-12 ml-3 mt-3">
                    <input class="form-check-input" type="checkbox" v-model="assignTicketUrl" /> Assign Ticket URL?
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-sm btn-primary pull-right" type="submit" @click.prevent="submit" :disabled="loading">Submit</button>
                  </div>
                </div>
              </section>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import moment from "moment";

export default {
  name: "betteruptimeTicketModal",
  data(){
    return {
      from: '',
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      subject: '',
      type: null,
      loading: false,
      sendTicketReply: false,
      index: null,
      action: 'Leave in migration',
      requiredTasks: [],
      presetMacros: [],
      outageDetail: {},
      tickets: [],
      assignTicketUrl: false,
      refreshDiskSpaceLoader: false,
      processingJobs: [],
      pendingJobListener: null
    }
  },
  mounted() {
    // this.getMonitorTickets()
  },
  beforeDestroy() {
    if(this.pendingJobListener) {
      this.pendingJobListener()
    }
  },
  computed: {
    userToken() {
      return this.$store.getters.getUserToken;
    },
    user () {
      return this.$store.getters.user;
    },
    recentTickets() {
      const tickets = this.tickets.filter(el => el.type !== 'domainExpiry');
      return tickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,2);
    }
  },
  watch: {
    processingJobs() {
      $('[data-toggle="tooltip"]').tooltip('dispose');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    }
  },
  methods: {
    async refreshDisk() {
      try {
        this.refreshDiskSpaceLoader = true;
        const response = await this.$http.post('disk/space', {
          user_id: 'N7uJSabGN5dLUlndus5rTUkpiW23' || this.user.uid,
          ip: '74.121.207.61' || this.outageDetail.serverIP,
          UID: 'N7uJSabGN5dLUlndus5rTUkpiW23' || this.user.uid,
          grant_type: "token",
          token: this.userToken
        });
        console.log(`response ${response.data}`)
      } catch (e) {
        console.log('something went wrong while refreshing diskspace');
      } finally {
        this.refreshDiskSpaceLoader = false;
      }
    },
    formatDate(date){
      return moment(date).local().fromNow()
    },
    async getMonitorTickets(){
      try{
        this.loading = true
        this.tickets = [];
        let ticketRef=await db.collection('monitorTickets').doc(this.outageDetail.id.toString()).get()
        if(ticketRef.exists){
          const {tickets} = ticketRef.data()
          this.tickets= tickets;
          this.tickets = this.tickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,2);
          const response = await this.$http.post('/host-bill/fetch-bulk-ticket-details', {
            grant_type: 'token',
            ticketData: this.tickets
          });
          console.log('response', response.data)
          this.tickets = response.data.ticketData
        }
      } catch (e) {
        console.log('error while getting ticket details', e.toString())
      } finally {
        this.loading = false
      }
    },
    async useThisMacro (macro) {
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      if(!this.outageDetail.uid) {
        let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
        domain = domain.split('/')[0];
        msg = msg.replace(/{domain}/g, domain)
        msg = msg.replace(/{signature}/g, this.user.signature)
        this.ticketMessage = msg;
        this.ticketStatus = (macro.status) ? macro.status : 'Answered';
        this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
        this.subject= macro.title ? macro.title.replace(/{domain}/g, domain) : ''
        this.loading = false
        return true
      }
      const userRef = await db.collection('users').doc(this.outageDetail.uid).get()
      const user = userRef.data()
      let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
      domain = domain.split('/')[0];
      msg = msg.replace(/{firstName}/g, user.firstName)
      msg = msg.replace(/{lastName}/g, user.lastName)
      msg = msg.replace(/{domain}/g, domain)
      msg = msg.replace(/{email}/g, user.email)
      msg = msg.replace(/{signature}/g, this.user.signature)
      if (msg.includes('{ipaddress}') || msg.includes('{maxStorage}') || msg.includes('{currentStorage}')) {
        const accountRef = await db.collection('hostingAccounts').doc(this.outageDetail.uid).get()
        const { accounts } = accountRef.data()
        let selectedAccount = null
        let selectedPlan = null
        for (const account of accounts) {
          if (account.primary.domain === this.outageDetail.url) {
            selectedAccount = account.primary;
            selectedPlan = account;
          }
        }
        if (selectedAccount) {
          const ip = selectedAccount.serverIP || 'N/A'
          msg = msg.replace(/{ipaddress}/g, ip )
        }
        if (selectedPlan) {
          // parse max storage
          if (msg.includes('{maxStorage}')) {
            const maxStorageSize = selectedPlan.maxStorageSize ? selectedPlan.maxStorageSize + ' GB' : 'N/A';
            msg = msg.replace(/{maxStorage}/g, maxStorageSize )
          }
          if (msg.includes('{currentStorage}')) {
            if(selectedPlan.fullDiskSpace && selectedPlan.fullDiskSpace.totalUsageObj && typeof selectedPlan.fullDiskSpace.totalUsageObj === 'string'){
              const currentStorage = (selectedPlan.fullDiskSpace.totalUsageObj !== 'undefined')
                  ? `${selectedPlan.fullDiskSpace.totalUsageObj}`: 0;
              msg = msg.replace(/{currentStorage}/g, currentStorage )
            }
            else{
              // parse current storage
              const currentStorage = (selectedPlan.fullDiskSpace && typeof selectedPlan.fullDiskSpace[2] !== 'undefined')
                  ? `${selectedPlan.fullDiskSpace[2].size} ${selectedPlan.fullDiskSpace[2].value}B`: 0;
              msg = msg.replace(/{currentStorage}/g, currentStorage )
            }

          }
        }
      }
      this.ticketMessage = msg;
      this.ticketStatus = (macro.status) ? macro.status : 'Answered';
      this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
      this.subject= macro.title ? macro.title.replace(/{domain}/g, domain) : ''
      this.loading = false
    },
    initialState() {
      return {
        ticketMessage: null,
        ticketStatus: 'Answered',
        ticketPriority: 'Low',
        subject: '',
        type: null,
        loading: false,
        sendTicketReply: false,
        index: null,
        action: 'Leave in migration',
        requiredTasks: [],
        presetMacros: [],
        outageDetail: {},
        tickets: [],
        assignTicketUrl: false,
      }
    },
    pendingjobs(docID){
      this.processingJobs = []
      const query = db.collection('jobLogs')
          .where('jobData.UID', '==', 'N7uJSabGN5dLUlndus5rTUkpiW23')
          .where('status', 'in', ['Pending', 'running'])
          .where('jobName', '==', 'refresh-storage')
          .where('jobData.ip', '==', '74.121.207.61');

      this.pendingJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            this.processingJobs.push({ ...change.doc.data(), id: change.doc.id })
          } else if (change.type === 'removed') {
            this.processingJobs =  this.processingJobs.filter(d=> d.id !== change.doc.id)
          }
        })
      });
    },
    async load (presets, outage, from) {
      Object.assign(this.$data, this.initialState());
      this.from = from;
      this.presetMacros=presets
      this.outageDetail=outage
      if (from === 'checkin' || from === 'ticketIcon') {
        this.assignTicketUrl = true
        const macro = this.presetMacros.find(reply => reply.title.includes('Issue detected on'))
        if (macro) {
          await this.useThisMacro(macro)
        }
        await this.submit(from)
      } else if (from === 'diskAlert') {
        this.assignTicketUrl = true
        const macro = this.presetMacros.find(reply => reply.title.includes('Storage Overage'))
        if (macro) {
          await this.useThisMacro(macro)
          this.ticketStatus = 'Requires Customer Update'
        }
      }
      if(from !== 'ticketIcon'){
        $('#betteruptimeTicketModal').modal('show');
      }
      await this.getMonitorTickets()
      if(from === 'diskAlert') {
        await this.pendingjobs()
      }
      console.log(outage)
    },
    async submit (from) {
      try {
        this.loading = true
        let accountRef = {}
        if(!this.outageDetail.uid) {
          if(this.outageDetail.nonWpoMonitor){
            accountRef.customerID = this.outageDetail.clientId || ''
          } else {
            return true
          }
        } else {
          accountRef = await db.collection('users').doc(this.outageDetail.uid).get();
          accountRef = accountRef.data();
        }
        let domain = this.outageDetail.url.includes('https://') ? this.outageDetail.url.split('https://')[1] : this.outageDetail.url
        domain = domain.split('/')[0];
        let response=await this.$http.post('host-bill/open-new-ticket', {
          domain,
          grant_type: 'token',
          message: this.ticketMessage,
          priority: this.ticketPriority,
          clientID: accountRef.customerID,
          subject: this.subject,
          status: this.ticketStatus,
          email: accountRef.email || '',
          name: this.user.firstName + ' ' + this.user.lastName
        })
        console.log('response', response)
        this.tickets.push({
          domain,
          subject: this.subject,
          message: this.ticketMessage,
          priority: this.ticketPriority,
          ticketId: response.data.ticket_id,
          status: this.ticketStatus,
          testId: this.outageDetail.id,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })
        await db.collection('monitorTickets').doc(this.outageDetail.id.toString()).set({tickets: this.tickets})
        if(this.assignTicketUrl || this.from === 'diskAlert'){
          await db.collection('zabbixMonitors').doc(this.outageDetail.id.toString())
              .update({currentTicket: {id: response.data.ticket_id, status: this.ticketStatus,},ticket_url: `https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`})
        }
        if(from === 'ticketIcon') {
          this.$emit('changeLoading', {id: this.outageDetail.id, flag: false })
        } else {
          swal({
            title: "Success",
            text: 'Ticket has been created successfully',
            type: "success"
          })
        }
        // window.open(`https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`, '_blank');
      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }finally
      {
        this.loading = false
        this.ticketMessage=''
        this.subject=''
        $('#betteruptimeTicketModal').modal('hide');

      }
    },
  }
}
</script>



<style lang="scss" scoped>
.preset {
  height: 230px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
